module.exports = __webpack_public_path__ + "img/phone1.9d3b6297.png";